// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => { };
export function stopPropagation(e) {
    e.stopPropagation();
}
